import { createContext, useContext, type ReactNode } from "react";

/**
 * Narrow feed chat columns shrink author avatars (ChatMessage + FeedPost) so
 * interleaved timeline extras match live messages. Provided by AskPunttChat
 * from the measured chat column width.
 */
const FeedCompactLayoutContext = createContext(false);

export function FeedCompactLayoutProvider({
  value,
  children,
}: {
  value: boolean;
  children: ReactNode;
}) {
  return (
    <FeedCompactLayoutContext.Provider value={value}>
      {children}
    </FeedCompactLayoutContext.Provider>
  );
}

export function useFeedCompactLayout(): boolean {
  return useContext(FeedCompactLayoutContext);
}
